(ns common.schema.entities.other-asset.core
  (:require [common.roles :as roles]
            [common.schema.entities.other-asset :as other-asset]))

;; Verbatim copy of common.schema.entity-types's shared crm-delete-check-fn,
;; which other-asset's existing entry references directly - required here,
;; not there, to avoid a circular namespace dependency (entity_types.cljc
;; requires this registry). Keep in sync if the original ever changes.
(defn- disable-permissions-check-fn
  [{:keys [tr role]}]
  (when-not (roles/user? role)
    (tr :not-allowed)))

(def entity-type-definition
  {:entity-type                  :entity.type/other-asset
   :schema                       other-asset/schema
   :name                         {:en "Generic asset"}
   :plural                       {:en "Generic assets"}
   :icon                         :fa-dna
   :create-icon                  :fa-dna
   :read-permissions-check-fn    (fn [{:keys []}] true)
   :disable-permissions-check-fn disable-permissions-check-fn

   ;; Explicitly false: other-asset's dedicated OpenSearch index already
   ;; exists and is populated via the legacy common.opensearch.entity-indices
   ;; mechanism, not the newer :entity/search-index?-driven
   ;; backend.search.dedicated.indexes/init! path - this key would otherwise
   ;; default to true just because :search is present below.
   :search-index?                false

   :search                       {:result/title-attr    :asset/name
                                  :list/default-columns [:asset/name
                                                         :asset/description
                                                         :asset/city
                                                         :other-asset/tag-tags]
                                  :views                {:grid {:po-default-field-paths [[:asset/name]
                                                                                         [:asset/description]
                                                                                         [:asset/city]
                                                                                         [:other-asset/tag-tags]]
                                                                :mandatory-field-paths  [[:asset/name]]}}}})
